<template>
  <div class="about_us_container">
    <div class="about_us_box">
      <div class="content_box">
        <p>农民日报客户端——一个基于“三农”资讯的全媒体互动平台。7*24小时为用户提供“三农”领域最及时的新闻资讯、最准确的信息数据、最权威的政策解读、最前沿的专家观点、最优质的原创内容。</p>
        <!-- <img :src="require('@/assets/images/download.jpg')" alt="" class="download" /> -->
        <p class="link">
          <a href="javascript:;" @click="toProtocol">农民日报客户端用户协议</a>
          <br>
          <a href="javascript:;" @click="toPrivate">农民日报客户端隐私政策</a>
          <br>
          <!-- <a href="javascript:;" @click="toCopyright">农民日报社公司版权声明</a> -->
          <a>APP备案号：京ICP备05068373号-2A</a><br>
          <span class="put">备案链接：<a href="https://beian.miit.gov.cn/">https://beian.miit.gov.cn/</a></span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
export default {
  name: "AboutUS",
  data() {
    return {
      pageData: {
        title: "关于我们",
        info: "",
        shareUrl: "",
        imageUrl: "",
      },
    };
  },
  computed: {
    ...mapState("app", ["shareRootUrl", "appFullName"]),
  },
  methods: {
    /* 跳转用户协议 */
    toProtocol() {
      if (window.java) {
        window.java.toProtocol();
      } else {
        this.$bridge.callhandler("toProtocol", null, (data) => { });
      }
    },
    /* 跳转隐私政策 */
    toPrivate() {
      if (window.java) {
        window.java.toPrivate();
      } else {
        this.$bridge.callhandler("toPrivate", null, (data) => { });
      }
    },
    /* 跳转版权声明 */
    toCopyright() {
      if (window.java) {
        window.java.toCopyright();
      } else {
        this.$bridge.callhandler("toCopyright", null, (data) => { });
      }
    }
  },
  created() {
    document.title = this.pageData.title;
    loadStat(); // 友盟统计
    this.pageData.info = this.appFullName;
    this.pageData.shareUrl = this.shareRootUrl + "about_us";
    this.pageData.imageUrl = this.shareRootUrl.replace("/#/", "/") + require('@/assets/images/logo/logo.png');
  },
  mounted() {
    var _this = this;
    window.setShareInfo = () => {
      var shareStr = JSON.stringify(_this.pageData);
      // 调用客户端方法，将分享信息传给客户端
      if (window.java) {
        window.java.setShareInfo(shareStr);
      } else {
        _this.$bridge.callhandler("setShareInfo", shareStr, (data) => { });
      }
    }
  },
};
</script>
<style scoped lang="scss">
.about_us_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: auto;
  .about_us_box {
    padding: 50px 0 32px;
  }
  .content_box {
    width: 65.61%;
    padding: 30px 0;
    margin: 0 auto;
    color: #1e1e1e;
    >div{
      font-size: 15.2px;
      line-height: 1.8em;
    }
    p {
      font-size: 15.2px;
      line-height: 1.8em;
      word-break: normal;
      text-align: justify;
      text-indent: 2em;
      &.link {
        line-height: 24px;
        text-indent: 0;
        margin-top: 32px;
        text-align: center;
        a {
          color: #777;
          font-size: 12px;
          text-decoration: none;
        }
        .put{
          color: #777;
          font-size: 12px;
          a{
            color: #2c53ff;
          }
        }
      }
    }
    .download {
      display: block;
      width: 43.2%;
      margin: 30px auto 0;
    }
  }
}
</style>